import React, {Component} from 'react';
import {connect} from 'react-redux';
import PopperTargetHelper from 'reactstrap/lib/PopperTargetHelper';
import RentCycleConstants from "../../constants/RentCycleConstants";

class MarketFooter extends Component {

    marketFooterText() {
        let props = this.props;
        let text;
        let greaterRegion = this.props.marketInfo.comparisonMarkets.length ? this.props.marketInfo.comparisonMarkets[0].greaterRegion: "";

        if ((greaterRegion === "Americas" || greaterRegion === "Europe" || greaterRegion === 'Asia Pacific')) {
            text = RentCycleConstants.DETAIL_FOOTER_TEXT_AMERICAS_EMEA
        }

        return text;
    }

    comparisonMarketFooterText() {
        let greaterRegion = this.props.marketInfo.comparisonMarkets.length ? this.props.marketInfo.comparisonMarkets[1].greaterRegion: "";
        const americasOrEmea = greaterRegion === 'Americas' || greaterRegion === 'Europe' || greaterRegion === 'Asia Pacific';

        return americasOrEmea ? RentCycleConstants.DETAIL_FOOTER_TEXT_AMERICAS_EMEA : RentCycleConstants.DETAIL_FOOTER_TEXT_APAC;
    }

    render() {
        const { rightPanel, marketQuarters } = this.props;
        let footerText = rightPanel ? this.comparisonMarketFooterText() : this.marketFooterText();
        let areaOnVacancy =  marketQuarters[0] && marketQuarters[0].areaOnVacancy;
        let areaOnCycle = marketQuarters[0] && marketQuarters[0].areaOnCycle;

       return <>
            <div className="market-footer-desktop">
                <p className={rightPanel ? 'market-footer-areaoncycle-comparison' : 'market-footer-areaoncycle'}>
                    <span className={rightPanel ? 'text-bold-comparison' : 'text-bold'}>{RentCycleConstants.DETAIL_FOOTER_TEXT}</span>
                    <span className={rightPanel ? 'text-regular-comparison' : 'text-regular'}>{areaOnVacancy}</span>
                </p>
                <p className={rightPanel ? 'market-footer-areaoncycle-comparison' : 'market-footer-areaoncycle'}>
                    <span className={rightPanel ? 'text-bold-comparison' : 'text-bold'}>{footerText}</span>
                    <span className={rightPanel ? 'text-regular-comparison' : 'text-regular'}>{areaOnCycle}</span>
                </p>
            </div>
        </>;
    }
}

const mapStateToProps = (state) => {
    return {
        rightPanel: state.comparisonMarkets.isRightPanelVisible
    };
};

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(MarketFooter);


